/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Chart_Series_PaceInputs */

const en_ui_chart_series_pace = /** @type {(inputs: Ui_Chart_Series_PaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pace (min/km)`)
};

const de_ui_chart_series_pace = /** @type {(inputs: Ui_Chart_Series_PaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo (min/km)`)
};

/**
* | output |
* | --- |
* | "Pace (min/km)" |
*
* @param {Ui_Chart_Series_PaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_chart_series_pace = /** @type {((inputs?: Ui_Chart_Series_PaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Chart_Series_PaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_chart_series_pace(inputs)
	return de_ui_chart_series_pace(inputs)
});